// import React from "react";
// import Layout from "@layouts/withoutNaviagtion/withoutNavigationLayout";
// // import "./map-vendor.scss";
// import { useParams } from "react-router-dom";
// import { useEffect, useState } from "react";
// import { getValue } from "@utils/lodash";
// import Loader from "@components/common/Loader";
// import _ from "lodash";
// import NoAccessPage from "@components/common/NoAccess";
// import SelfComplianceTaskNavigation from "@components/Tasks/task-self-compliance-navigation";
// import {
//   UpdateSelfComplianceTask,
//   getSpecificSelfComplianceTask,
//   getSpecificSelfComplianceTaskEvaluator,
//   getSpecificSelfComplianceTaskExecutor,
// } from "@services/self-compliance.service";
// import { QueryRequestHelper } from "@_common/query-request-helper";
// import { getEntityGroups } from "@services/entity-mapping.service";
// import TaskDetailsCommon from "@components/common/TaskDetails";
// import OrganizationInformationCommon from "@pages/Activities/OrgInfoCommon";
// import { clientAdminFileUpload } from "@services/client-list.service";
// import { toast } from "react-toastify";
// import { NewDate } from "@_common/date-helpers";
// import { useNavigate } from "react-router-dom";
// import { getSpecificLegacyTask } from "@services/email-template.service";
// import SelfComplianceUpdatePopup from "@components/common/SelfComplianceDetail/UpdateTaskPopup";
// import CommonLegacyTaskDetailsTasks from "../../TaskDetailsComponent/task-details";
// import CommonLegacyTaskOrganizationInformation from "../../TaskDetailsComponent/orgInfo";
// import CommonLegacyTaskNavigation from "../../TaskDetailsComponent/task-self-compliance-navigation";
// // import SelfComplianceUpdatePopup from "../UpdateTaskPopup";

// export default function LegacyTaskExecutorDetailsPage(props: any) {
//   let mainParams = useParams();
//   const navigate = useNavigate();
//   /* -------------------------------------------------------------------------- */
//   /*                               UseState Section                             */
//   /* -------------------------------------------------------------------------- */

//   const [loading, setLoading] = useState(true);
//   const [data, setData] = useState<any>({});
//   const [request, setRequest] = useState<any>({
//     follow_up_date: "",
//     renewal_reminder_date: "",
//     expiry_date: "",
//     completion_date: "",
//     work_status: "",
//     license_number: "",
//     license_status: "",
//     non_compliance_reason: "",
//     evaluator_comments: "",
//     is_no_expiry_task: false,
//     document_ids: [
//       {
//         id: "",
//       },
//     ],
//   });
//   const [selectedStatus, setSelectedStatus] = useState("");
//   const [userInfo, setUserInfo] = useState({});

//   /* -------------------------------------------------------------------------- */
//   /*                               UseEffect Section                            */
//   /* -------------------------------------------------------------------------- */

//   useEffect(() => {
//     const urlSearchParams = new URLSearchParams(window.location.search);
//     const params = Object.fromEntries(urlSearchParams.entries());
//     if (Object.keys(params).length === 0 && props.permissionAPITriggered) {
//       getData();
//       getHeaderList();
//     }
//     let userInfo = getValue(localStorage, `user`, {});
//     let user = JSON.parse(userInfo);
//     if (getValue(user, `id`, "")) {
//       setUserInfo(user);
//     }
//   }, [props.permissionAPITriggered]);
//   useEffect(() => {
//     const urlSearchParams = new URLSearchParams(window.location.search);
//     const params = Object.fromEntries(urlSearchParams.entries());
//     if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
//       getData();
//       getHeaderList();
//     }
//   }, [window.location.href, props.permissionAPITriggered]);

//   /* -------------------------------------------------------------------------- */
//   /*                               API Section                                  */
//   /* -------------------------------------------------------------------------- */
//   const getData = async () => {
//     try {
//       setLoading(true);
//       let resp;
//     //   if (route[3] === "my-task") {
//     //     resp = await getSpecificSelfComplianceTaskExecutor(mainParams.id);
//     //   } else if (route[3] === "pending-approval") {
//     //     resp = await getSpecificSelfComplianceTaskEvaluator(mainParams.id);
//     //   } else {
//     //     resp = await getSpecificLegacyTask(mainParams.id);
//     //   }
//       resp = await getSpecificLegacyTask(mainParams.id);
//       if (resp) {
//         setData(getValue(resp, `data`, {}));
//         setRequest({
//           ...request,
//           follow_up_date: getValue(resp, `data.follow_up_date`, "")
//             ? new Date(getValue(resp, `data.follow_up_date`, ""))
//             : null,
//           completion_date: getValue(resp, `data.completion_date`, "")
//             ? new Date(getValue(resp, `data.completion_date`, ""))
//             : null,
//           expiry_date: getValue(resp, `data.expiry_date`, "")
//             ? new Date(getValue(resp, `data.expiry_date`, ""))
//             : null,
//           compliance_status: getValue(resp, `data.compliance_status`, ""),
//           license_number: getValue(resp, `data.license_number`, ""),
//           work_status: getValue(resp, `data.work_status`, ""),
//           license_status: getValue(resp, `data.license_status`, ""),
//           non_compliance_reason: getValue(
//             resp,
//             `data.non_compliance_reason`,
//             ""
//           ),
//           is_no_expiry_task: getValue(resp, `data.is_no_expiry_task`, false),
//           document_ids: getValue(resp, `documents`, []),
//         });
//         setLoading(false);
//       } else {
//         setLoading(false);
//       }
//     } catch (error) {
//       setLoading(false);
//     }
//   };
//   const [headerObj] = useState<any>({});
//   const getHeaderList = async () => {
//     const urlSearchParams = new URLSearchParams(window.location.search);
//     const params = Object.fromEntries(urlSearchParams.entries());
//     let payload: any = {
//       status: params.status ? params.status : "",
//       sort_by: params.sort_by,
//     };
//     let queryRequest = QueryRequestHelper(payload);
//     try {
//       let resp = await getEntityGroups(queryRequest);
//       if (resp) {
//         getValue(resp, `data.entityGroups`, []).map((item: any) => {
//           return (headerObj[
//             `level_${getValue(item, `group_level`, "")}`
//           ] = getValue(item, `group_name`, ""));
//         });
//       }
//     } catch (error) {}
//   };

//   /* ---------------------------  Update Modal  ----------------------------- */
//   const [selectedId, setSelectedId] = useState("");
//   const [showUpdatePopup, setShowUpdatePopup] = useState(false);
//   const [submitLoading, setSubmitLoading] = useState(false);
//   const [selfCompliance, setSelfCompliance] = useState<any>({
//     completion_date: "",
//     compliance_status: "",
//     work_status: "",
//     remarks: "",
//     non_compliance_reason: "",
//     event_not_occured: false,
//     document_ids: [],
//     evaluator_comments: "",
//   });
//   const [complianceStatusList] = useState([
//     { value: "ASSIGNED", label: "Assigned" },
//     { value: "POSING", label: "Posing" },
//     { value: "PENDING_FOR_APPROVAL", label: "Pending For Approval" },
//     { value: "COMPLIED", label: "Complied" },
//     { value: "NON_COMPLIED", label: "Non Complied" },
//     { value: "DELAYED", label: "Delayed" },
//     { value: "DELAYED_REPORTED", label: "Delay Reported" },
//     { value: "RE_OPENED", label: "Re Opened" },
//   ]);

//   const handleSubmitTask = async (status: string) => {
//     let url = window.location.pathname.split("/");
//     const urlSearchParams = new URLSearchParams(window.location.search);
//     const params = Object.fromEntries(urlSearchParams.entries());
//     let payload: any = {
//       ...params,
//     };
//     let queryRequest = QueryRequestHelper(payload);
//     if (getValue(selfCompliance, `completion_date`, "")) {
//       setSelectedStatus(status);
//       try {
//         let obj = JSON.parse(JSON.stringify(selfCompliance));
//         if (status === "COMPLIED" || status === "RE_OPENED") {
//           obj["compliance_status"] = status;
//         } else {
//           obj["approval_status"] = "APPROVED";
//         }
//         obj["document_ids"] =
//           getValue(selfCompliance, `document_ids.length`, 0) > 0
//             ? getValue(
//                 selfCompliance,
//                 `document_ids`,
//                 []
//               ).map((item: object) => ({ id: getValue(item, `id`, "") }))
//             : [];

//         if (
//           (getValue(data, `self_compliance.document_required`, false)
//             ? getValue(selfCompliance, `document_ids.length`, 0) > 0
//               ? false
//               : true
//             : false) &&
//           !getValue(selfCompliance, `event_not_occured`, false)
//         ) {
//           toast.error("Documents required");
//         } else {
//           setSubmitLoading(true);
//           let resp = await UpdateSelfComplianceTask(
//             getValue(mainParams, `id`, ""),
//             obj
//           );
//           if (resp) {
//             toast.success(getValue(resp, `message`, ""));
//             setSubmitLoading(false);
//             setShowUpdatePopup(false);
//             setSelfCompliance({
//               ...selfCompliance,
//               completion_date: "",
//               compliance_status: "",
//               work_status: "",
//               remarks: "",
//               non_compliance_reason: "",
//               event_not_occured: false,
//               document_ids: [],
//             });
//             navigate(
//               `/${getValue(url, `[${1}]`, "")}/${getValue(
//                 url,
//                 `[${2}]`,
//                 ""
//               )}/${getValue(url, `[${3}]`, "")}?${queryRequest}`
//             );
//           } else {
//             setSubmitLoading(false);
//           }
//         }
//       } catch (error) {
//         setSubmitLoading(false);
//       }
//     } else {
//       toast.error("Completion date is mandatory");
//     }
//   };
//   const handleClickPopup = () => {
//     let obj = data;
//     setShowUpdatePopup(!showUpdatePopup);
//     setSelectedId(getValue(obj, `id`, ""));
//     setSelfCompliance({
//       ...selfCompliance,
//       completion_date: getValue(obj, `completion_date`, null)
//         ? NewDate(getValue(obj, `completion_date`, null))
//         : new Date(),
//       compliance_status: getValue(obj, `compliance_status`, null),
//       work_status: getValue(obj, `work_status`, null),
//       remarks: getValue(obj, `remarks`, null),
//       non_compliance_reason: getValue(obj, `non_compliance_reason`, null),
//       evaluator_comments: getValue(obj, `evaluator_comments`, null),
//       event_not_occured: getValue(obj, `event_not_occured`, false),
//       document_ids: getValue(obj, `documents`, []),
//     });
//   };
//   /* -------------------------  Upload Document  ------------------------------ */
//   const [uploadLoading, setUploadLoading] = useState(false);
//   const removeDocument = (id: string) => {
//     let filtered =
//       getValue(selfCompliance, `document_ids.length`, 0) > 0
//         ? getValue(selfCompliance, `document_ids`, []).filter(
//             (item: any) => item.id !== id
//           )
//         : [];
//     setSelfCompliance({
//       ...selfCompliance,
//       document_ids: filtered,
//     });
//   };
//   const handleUploadDocuments = async (e: any) => {
//     Array.from(e).forEach(async (item: any) => {
//       let formData = new FormData();
//       formData.append("file", item);
//       try {
//         setUploadLoading(true);
//         let resp = await clientAdminFileUpload(formData);
//         if (resp) {
//           getValue(selfCompliance, `document_ids`, "").push(
//             getValue(resp, `data`, {})
//           );
//           setSelfCompliance({ ...selfCompliance });
//           e = null;
//           setUploadLoading(false);
//         } else {
//           e = null;
//           setUploadLoading(false);
//         }
//       } catch (error) {
//         e = null;
//         setUploadLoading(false);
//       }
//     });

//     // Array.from(e.target.files).forEach(async (item: any) => {
//     //   let formData = new FormData();
//     //   formData.append("file", item);
//     //   try {
//     //     setUploadLoading(true);
//     //     let resp = await clientAdminFileUpload(formData);
//     //     if (resp) {
//     //       await selfCompliance.document_ids.push(getValue(resp, `data`, {}));
//     //       setSelfCompliance({ ...selfCompliance });
//     //       e.target.value = null;
//     //     } else {
//     //       e.target.value = null;
//     //     }
//     //   } catch (error) {
//     //     e.target.value = null;
//     //   }
//     //   setUploadLoading(false);
//     // });
//   };
//   const handleDrop = (e: any) => {
//     e.preventDefault();
//     const files = Array.from(e.dataTransfer.files);
//     files.forEach(async (item: any) => {
//       let formData = new FormData();
//       formData.append("file", item);
//       try {
//         setUploadLoading(true);
//         let resp = await clientAdminFileUpload(formData);
//         if (resp) {
//           await selfCompliance.document_ids.push(getValue(resp, `data`, {}));
//           setSelfCompliance({ ...selfCompliance });
//           e.target.value = null;
//         } else {
//           e.target.value = null;
//         }
//       } catch (error) {
//         e.target.value = null;
//       }
//       setUploadLoading(false);
//     });
//   };
//   const handleDragOver = (event: any) => {
//     event.preventDefault();
//   };
//   const disableUpload = () => {};

//   const getSpecificPermissions = (permission: string) => {
//     switch (permission) {
//       // case "my-task":
//       //   return "activities_self_compliance_executor_task";
//       // case "pending-approval":
//       //   return "activities_self_compliance_evaluator_approval";
//       // case "approved-task":
//       //   return "activities_self_compliance_completed_task";
//       // case "master":
//       //   return "repository_mapped_checkpoint_master";
//       // case "function-head":
//       //   return "repository_mapped_checkpoint_function_head";
//       // case "evaluator":
//       //   return "repository_mapped_checkpoint_evaluator";
//       // case "pending-audit":
//       //   return "audit_compliance_audit_pending";
//       // case "completed-audit":
//       //   return "audit_compliance_audit_completed";
//       case "executor":
//         return "repository_legacy_task_executor";
//       default:
//         return null;
//     }
//   };

//   const getUserPermission = (permission: string, data: any) => {
//     switch (permission) {
//       case "my-task":
//         return getValue(data, `executor.id`, "") ===
//           getValue(userInfo, `id`, "")
//           ? true
//           : false;
//       case "pending-approval":
//         return getValue(data, `evaluator.id`, "") ===
//           getValue(userInfo, `id`, "")
//           ? true
//           : false;

//       case "function_head":
//         return getValue(data, `function_head.id`, "") ===
//           getValue(userInfo, `id`, "")
//           ? true
//           : false;
//       default:
//         return true;
//     }
//   };
//   let route = window.location.pathname.split("/");
//   const urlSearchParams = new URLSearchParams(window.location.search);
//   const params = Object.fromEntries(urlSearchParams.entries());
//   console.log(route[3]);
//   return (
//     <>
//       <div className="master-inner-details-grey-bg">
//         <Layout>
//           {getValue(params, `request_from`, "") !== "MASTER" &&
//           !loading &&
//           !getValue(props, `subTabPermissionList`, []).includes(
//             getSpecificPermissions(route[3])
//           ) ? (
//             <NoAccessPage />
//           ) : (
//             <>
//               {loading || !props.permissionAPITriggered ? (
//                 <Loader />
//               ) : !getUserPermission(route[3], data) ? (
//                 <NoAccessPage />
//               ) : (
//                 <div className="master-details-page-main">
//                   <CommonLegacyTaskNavigation
//                     id={mainParams.id}
//                     lexcare_task_id={mainParams.lexcare_task_id}
//                     permissions={props.permissions}
//                     handleClickPopup={handleClickPopup}
//                     showTaskInfo
//                     params={mainParams}
//                     status={
//                       getValue(data, `approval_status`, "") === "APPROVED"
//                         ? getValue(data, `approval_status`, "")
//                         : getValue(data, `compliance_status`, "")
//                     }
//                     global_route={route[1]}
//                     parent_route={route[2]}
//                     main_route={route[3]}
//                   />
//                   <div className="map-vendor-wrapper map-vendor-wrapper--task-details w-100">
//                     <div className="map-vendor__details map-vendor__details--task-details d-flex align-items-flex-start px-0 my-0">
//                       <>
//                         <CommonLegacyTaskDetailsTasks
//                           data={data}
//                         />
//                         <CommonLegacyTaskOrganizationInformation
//                           data={data}
//                           headerObj={headerObj}
//                           getData={getData}
//                           permissions={getValue(props, `permissions`, [])}
//                           {...mainParams}
//                         />
//                       </>
//                     </div>
//                     <div className="w-100 footer-wrapper--task d-none">
//                       <img
//                         src="/images/footer-image.svg"
//                         className="img-fluid footer-image"
//                       />
//                     </div>
//                   </div>
//                 </div>
//               )}
//             </>
//           )}
//           <SelfComplianceUpdatePopup
//             showUpdatePopup={showUpdatePopup}
//             setShowUpdatePopup={setShowUpdatePopup}
//             setSelfCompliance={setSelfCompliance}
//             selfCompliance={selfCompliance}
//             handleUploadDocuments={handleUploadDocuments}
//             handleSubmitTask={handleSubmitTask}
//             submitLoading={submitLoading}
//             complianceStatusList={complianceStatusList}
//             parent_route={route[1]}
//             main_route={route[3]}
//             sub_route={route[3]}
//             removeDocument={removeDocument}
//             selectedStatus={selectedStatus}
//             selectedObj={data}
//             uploadLoading={uploadLoading}
//             handleDrop={handleDrop}
//             handleDragOver={handleDragOver}
//             disableUpload={disableUpload}
//             permissions={getValue(props, `permissions`, [])}
//             inside={true}
//             params={params}
//           />
//         </Layout>
//       </div>
//     </>
//   );
// }

import React from "react";
import Layout from "@layouts/withoutNaviagtion/withoutNavigationLayout";
// import "./map-vendor.scss";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { getValue } from "@utils/lodash";
import Loader from "@components/common/Loader";
import _ from "lodash";
import NoAccessPage from "@components/common/NoAccess";
import SelfComplianceTaskNavigation from "@components/Tasks/task-self-compliance-navigation";
import {
  UpdateSelfComplianceTask,
  getSpecificSelfComplianceTask,
  getSpecificSelfComplianceTaskEvaluator,
  getSpecificSelfComplianceTaskExecutor,
} from "@services/self-compliance.service";
import { QueryRequestHelper } from "@_common/query-request-helper";
import { getEntityGroups } from "@services/entity-mapping.service";
import TaskDetailsCommon from "@components/common/TaskDetails";
import OrganizationInformationCommon from "@pages/Activities/OrgInfoCommon";
import { LegacyTaskFileDelete, LegacyTaskFileUpload, clientAdminFileUpload } from "@services/client-list.service";
import { toast } from "react-toastify";
import { NewDate } from "@_common/date-helpers";
import { useNavigate } from "react-router-dom";
import { UpdateLegacyTask, getSpecificLegacyTask } from "@services/email-template.service";
import LegacyTaskEditTask from "../../TaskDetailsComponent/edit-task";
import CommonLegacyTaskNavigation from "../../TaskDetailsComponent/task-self-compliance-navigation";
import CommonLegacyTaskDetailsTasks from "../../TaskDetailsComponent/task-details";
import CommonLegacyTaskOrganizationInformation from "../../TaskDetailsComponent/orgInfo";
// import SelfComplianceUpdatePopup from "../UpdateTaskPopup";

export default function LegacyTaskDetailsPage(props: any) {
  let mainParams = useParams();
  const navigate = useNavigate();
  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<any>({});
  const [request, setRequest] = useState<any>({
    status: "",
    document_ids: [
      {
        id: "",
      },
    ],
  });
  const [selectedStatus, setSelectedStatus] = useState("");
  const [userInfo, setUserInfo] = useState({});

  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length === 0 && props.permissionAPITriggered) {
      getData();
      getHeaderList();
    }
    let userInfo = getValue(localStorage, `user`, {});
    let user = JSON.parse(userInfo);
    if (getValue(user, `id`, "")) {
      setUserInfo(user);
    }
  }, [props.permissionAPITriggered]);
  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
      getData();
      getHeaderList();
    }
  }, [window.location.href, props.permissionAPITriggered]);

  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */
  const getData = async () => {
    try {
      setLoading(true);
      let resp;
    //   if (route[3] === "my-task") {
    //     resp = await getSpecificSelfComplianceTaskExecutor(mainParams.id);
    //   } else if (route[3] === "pending-approval") {
    //     resp = await getSpecificSelfComplianceTaskEvaluator(mainParams.id);
    //   } else {
    //     resp = await getSpecificLegacyTask(mainParams.id);
    //   }
      resp = await getSpecificLegacyTask(mainParams.id);
      if (resp) {
        setData(getValue(resp, `data`, {}));
        setRequest({
          ...request,
          status: getValue(resp, `data.status`, ""),
          document_ids: getValue(resp, `documents`, []),
        });
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };
  const [headerObj] = useState<any>({});
  const getHeaderList = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      status: params.status ? params.status : "",
      sort_by: params.sort_by,
    };
    let queryRequest = QueryRequestHelper(payload);
    try {
      let resp = await getEntityGroups(queryRequest);
      if (resp) {
        getValue(resp, `data.entityGroups`, []).map((item: any) => {
          return (headerObj[
            `level_${getValue(item, `group_level`, "")}`
          ] = getValue(item, `group_name`, ""));
        });
      }
    } catch (error) {}
  };

  /* ---------------------------  Update Modal  ----------------------------- */
  const [selectedId, setSelectedId] = useState("");
  const [showUpdatePopup, setShowUpdatePopup] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [selfCompliance, setSelfCompliance] = useState<any>({
    status: "",
    remark: "",
    document_ids: [],
  });
  const [complianceStatusList] = useState([
    { value: "ASSIGNED", label: "Assigned" },
    { value: "POSING", label: "Posing" },
    { value: "COMPLIED", label: "Complied" },
    { value: "NON_COMPLIED", label: "Non Complied" },
    { value: "DELAYED", label: "Delayed" },
    { value: "DELAYED_REPORTED", label: "Delay Reported" },
    { value: "RE_OPENED", label: "Re Opened" },
    { value: "EVENT_NOT_OCCURED", label: "Event Not Occured" },
    { value: "AWAITING_APPROVAL", label: "Awaiting Approval" },
  ]);

  const handleSubmitTask = async (status: string) => {
    let url = window.location.pathname.split("/");
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
    };
    let queryRequest = QueryRequestHelper(payload);
    // if (getValue(selfCompliance, `completion_date`, "")) {
      setSelectedStatus(status);
      try {
        let obj = JSON.parse(JSON.stringify(selfCompliance));
        // if (status === "COMPLIED" || status === "RE_OPENED") {
        //   obj["compliance_status"] = status;
        // } else {
        //   obj["approval_status"] = "APPROVED";
        // }
        obj["document_ids"] =
          getValue(selfCompliance, `document_ids.length`, 0) > 0
            ? getValue(
                selfCompliance,
                `document_ids`,
                []
              ).map((item: object) => ({ id: getValue(item, `id`, "") }))
            : [];

        if (
          (getValue(data, `self_compliance.document_required`, false)
            ? getValue(selfCompliance, `document_ids.length`, 0) > 0
              ? false
              : true
            : false) &&
          !getValue(selfCompliance, `event_not_occured`, false)
        ) {
          toast.error("Documents required");
        } else {
          setSubmitLoading(true);
          let resp = await UpdateLegacyTask(
            getValue(mainParams, `id`, ""),
            obj
          );
          console.log(resp);
          if (resp) {
            toast.success(getValue(resp, `message`, ""));
            setSubmitLoading(false);
            setShowUpdatePopup(false);
            setSelfCompliance({
              ...selfCompliance,
              status: "",
              remark: "",
              document_ids: [],
            });
            navigate(
              `/${getValue(url, `[${1}]`, "")}/${getValue(
                url,
                `[${2}]`,
                ""
              )}/${getValue(url, `[${3}]`, "")}?${queryRequest}`
            );
          } else {
            setSubmitLoading(false);
          }
        }
      } catch (error) {
        setSubmitLoading(false);
      }
    // } else {
    //   toast.error("Completion date is mandatory");
    // }
  };
  
  function formatStatus(status:any) {
    return status.toUpperCase().replace(/ /g, "_");
  }


  const handleClickPopup = () => {
    let obj = data;
    setShowUpdatePopup(!showUpdatePopup);
    setSelectedId(getValue(obj, `id`, ""));
    console.log(obj, "OBJ-----------------------")
    setSelfCompliance({
      ...selfCompliance,
      // completion_date: getValue(obj, `completion_date`, null)
      //   ? NewDate(getValue(obj, `completion_date`, null))
      //   : new Date(),
      // compliance_status: getValue(obj, `compliance_status`, null),
      // work_status: getValue(obj, `work_status`, null),
      // remarks: getValue(obj, `remarks`, null),
      // non_compliance_reason: getValue(obj, `non_compliance_reason`, null),
      // evaluator_comments: getValue(obj, `evaluator_comments`, null),
      // event_not_occured: getValue(obj, `event_not_occured`, false),
      // document_ids: getValue(obj, `documents`, []),
      status: formatStatus(getValue(obj, `status`, "" )),
      remark: getValue(obj, `remark`, ""),
      document_ids: getValue(obj, `documents`, []),
    });
  };
  /* -------------------------  Upload Document  ------------------------------ */
  const [uploadLoading, setUploadLoading] = useState(false);
  const removeDocument = async (id: string) => {
    // let filtered =
    //   getValue(selfCompliance, `document_ids.length`, 0) > 0
    //     ? getValue(selfCompliance, `document_ids`, []).filter(
    //         (item: any) => item.id !== id
    //       )
    //     : [];
    // setSelfCompliance({
    //   ...selfCompliance,
    //   document_ids: filtered,
    // });
    
    let resp = await LegacyTaskFileDelete(id);
    if (resp) {
        let filtered =
        getValue(selfCompliance, `document_ids.length`, 0) > 0
          ? getValue(selfCompliance, `document_ids`, []).filter(
              (item: any) => item.id !== id
            )
          : [];
      setSelfCompliance({
        ...selfCompliance,
        document_ids: filtered,
      });
    }
  };
  const handleUploadDocuments = async (e: any) => {
    Array.from(e).forEach(async (item: any) => {
      let formData = new FormData();
      formData.append("file", item);
      formData.append("ttrn_id", mainParams.id);
      formData.append("is_client", "true");

      setUploadLoading(true);
      try {
        let resp = await LegacyTaskFileUpload(formData);
        if (resp) {
          getValue(selfCompliance, `document_ids`, "").push(
            getValue(resp, `data`, {})
          );
          setSelfCompliance({ ...selfCompliance });
          e = null;
          setUploadLoading(false);
        } else {
          e = null;
          setUploadLoading(false);
        }
      } catch (error) {
        e = null;
        setUploadLoading(false);
      }
    });

    // Array.from(e.target.files).forEach(async (item: any) => {
    //   let formData = new FormData();
    //   formData.append("file", item);
    //   try {
    //     setUploadLoading(true);
    //     let resp = await clientAdminFileUpload(formData);
    //     if (resp) {
    //       await selfCompliance.document_ids.push(getValue(resp, `data`, {}));
    //       setSelfCompliance({ ...selfCompliance });
    //       e.target.value = null;
    //     } else {
    //       e.target.value = null;
    //     }
    //   } catch (error) {
    //     e.target.value = null;
    //   }
    //   setUploadLoading(false);
    // });
  };
  const handleDrop = (e: any) => {
    e.preventDefault();
    const files = Array.from(e.dataTransfer.files);
    files.forEach(async (item: any) => {
      let formData = new FormData();
      formData.append("file", item);
      try {
        setUploadLoading(true);
        let resp = await clientAdminFileUpload(formData);
        if (resp) {
          await selfCompliance.document_ids.push(getValue(resp, `data`, {}));
          setSelfCompliance({ ...selfCompliance });
          e.target.value = null;
        } else {
          e.target.value = null;
        }
      } catch (error) {
        e.target.value = null;
      }
      setUploadLoading(false);
    });
  };
  const handleDragOver = (event: any) => {
    event.preventDefault();
  };
  const disableUpload = () => {};

  const getSpecificPermissions = (permission: string) => {
    switch (permission) {
      case "executor":
        return "repository_legacy_task_executor";
      default:
        return null;
    }
  };

  const getUserPermission = (permission: string, data: any) => {
    switch (permission) {
      case "my-task":
        return getValue(data, `executor.id`, "") ===
          getValue(userInfo, `id`, "")
          ? true
          : false;
      case "pending-approval":
        return getValue(data, `evaluator.id`, "") ===
          getValue(userInfo, `id`, "")
          ? true
          : false;

      case "function_head":
        return getValue(data, `function_head.id`, "") ===
          getValue(userInfo, `id`, "")
          ? true
          : false;
      default:
        return true;
    }
  };
  let route = window.location.pathname.split("/");
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  return (
    <>
      <div className="master-inner-details-grey-bg">
        <Layout>
          {getValue(params, `request_from`, "") !== "MASTER" &&
          !loading &&
          !getValue(props, `subTabPermissionList`, []).includes(
            getSpecificPermissions(route[3])
          ) ? (
            <NoAccessPage />
          ) : (
            <>
              {loading || !props.permissionAPITriggered ? (
                <Loader />
              ) : !getUserPermission(route[3], data) ? (
                <NoAccessPage />
              ) : (
                <div className="master-details-page-main">
                  <CommonLegacyTaskNavigation
                    id={mainParams.id}
                    lexcare_task_id={mainParams.lexcare_task_id}
                    permissions={props.permissions}
                    handleClickPopup={handleClickPopup}
                    showTaskInfo
                    params={mainParams}
                    status={
                      getValue(data, `approval_status`, "") === "APPROVED"
                        ? getValue(data, `approval_status`, "")
                        : getValue(data, `compliance_status`, "")
                    }
                    global_route={route[1]}
                    parent_route={route[2]}
                    main_route={route[3]}
                  />
                  <div className="map-vendor-wrapper map-vendor-wrapper--task-details w-100">
                    <div className="map-vendor__details map-vendor__details--task-details d-flex align-items-flex-start px-0 my-0">
                      <>
                        <CommonLegacyTaskDetailsTasks
                          data={data}
                        />
                        <CommonLegacyTaskOrganizationInformation
                          data={data}
                          headerObj={headerObj}
                          getData={getData}
                          permissions={getValue(props, `permissions`, [])}
                          {...mainParams}
                        />
                      </>
                    </div>
                    <div className="w-100 footer-wrapper--task d-none">
                      <img
                        src="/images/footer-image.svg"
                        className="img-fluid footer-image"
                      />
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
          <LegacyTaskEditTask
            showUpdatePopup={showUpdatePopup}
            setShowUpdatePopup={setShowUpdatePopup}
            setSelfCompliance={setSelfCompliance}
            selfCompliance={selfCompliance}
            handleUploadDocuments={handleUploadDocuments}
            handleSubmitTask={handleSubmitTask}
            submitLoading={submitLoading}
            complianceStatusList={complianceStatusList}
            parent_route={route[1]}
            main_route={route[3]}
            sub_route={route[3]}
            removeDocument={removeDocument}
            selectedStatus={selectedStatus}
            selectedObj={data}
            uploadLoading={uploadLoading}
            handleDrop={handleDrop}
            handleDragOver={handleDragOver}
            disableUpload={disableUpload}
            permissions={getValue(props, `permissions`, [])}
            inside={true}
            params={params}
          />
        </Layout>
      </div>
    </>
  );
}